import React, { Component } from 'react';
import {
  SimpleForm,
  TextInput,
  FileInput,
  Toolbar,
  SaveButton,
  translate
} from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';
import FlagPreview from './FlagPreview';

const FLAG_MAX_BYTES = 2 * 1024 * 1024;

function PaisToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

function validatePaisForm(values) {
  const errors = {};
  if (values.flag && values.flag.rawFile && values.flag.rawFile.size > FLAG_MAX_BYTES) {
    errors.flag = 'La bandera no puede superar 2 MB';
  }
  return errors;
}

class PaisForm extends Component {
  render() {
    const { mode, ...rest } = this.props;
    const isCreate = mode === 'create';
    const flagValidate = isCreate ? isRequired : undefined;
    return (
      <SimpleForm
        {...rest}
        toolbar={<PaisToolbar />}
        validate={validatePaisForm}
      >
        {this.props.children}
        <FieldGroup label="fieldGroups.pais">
          <TextInput source="name" validate={isRequired} />
          <FileInput
            source="flag"
            label="resources.paises.fields.flag"
            accept="image/*"
            validate={flagValidate}
          >
            <FlagPreview />
          </FileInput>
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(PaisForm);
